import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import moment from 'moment';
import {
    HorizontalFlex,
    Label,
    PadContainer,
    Ticket,
    TicketBody,
    TicketHeader,
} from 'smartsuite-ui';
import PropTypes from 'prop-types';
import { getUrlForNodeDetails } from '../utils/nodeDetails';
import detailsLabelCases from '../constants/detailsLabelCases';
import nodeStyles from '../constants/nodeStyles';

function DateTimeString({ timestamp }) {
    if (!timestamp) {
        return '-';
    }
    //add dash
    const dayOfMonth = moment(timestamp).format('DD');
    const month = moment(timestamp).format('MMM').toUpperCase();
    const time = moment(timestamp).format('HH:mm'); //TODO:need to get local time.

    return (
        <div className="detail-ticket__header">
            {dayOfMonth}
            {month} -<span className="detail-ticket__time">{time}L</span>
        </div>
    );
}

export default function DetailItemContent({ nodeDetail, urlData }) {
    const { t } = useTranslation('bagSummary');

    function nodeMatchesLabelCase(node, labelCase) {
        return (
            labelCase.nodeTypes.includes(node.description) &&
            (!labelCase.state || labelCase.state === node.state)
        );
    }

    function getTranslationKeyForNodeDetails(node) {
        const labelCase = detailsLabelCases.find((x) =>
            nodeMatchesLabelCase(node, x)
        );
        return labelCase?.translationKey ?? 'Missing Translation';
    }

    const ticketBodyClassName =
        nodeDetail.style === nodeStyles.critical
            ? 'details-tickets__body-critical'
            : 'details-tickets__body';

    const nodeUrls = getUrlForNodeDetails(nodeDetail, urlData);

    const translation = (
        <Trans
            i18nKey={getTranslationKeyForNodeDetails(nodeDetail)}
            t={t}
            values={{
                ...nodeDetail.extensionProperties,
                actualActivationText: nodeDetail.extensionProperties
                    .WorkstationName
                    ? t('activationText', nodeDetail.extensionProperties)
                    : t('bagActivated'),
            }}
            components={{
                flightlink:
                    nodeDetail.extensionProperties.FlightId > 0 ? (
                        <a
                            href={nodeUrls[0]}
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                    ) : (
                        <span />
                    ),
                oldflightlink:
                    nodeDetail.extensionProperties.OldFlightId > 0 ? (
                        <a
                            href={nodeUrls[0]}
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                    ) : (
                        <span />
                    ),
                newflightlink:
                    nodeDetail.extensionProperties.NewFlightId > 0 ? (
                        <a
                            href={nodeUrls[1]}
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                    ) : (
                        <span />
                    ),
                a: (
                    <a
                        href={nodeUrls[0]}
                        target="_blank"
                        rel="noopener noreferrer"
                    />
                ),
            }}
        />
    );

    return (
        <>
            <Ticket cssClassModifiers={['always-row']}>
                <TicketHeader cssClassModifiers={['border-bottom']}>
                    <PadContainer cssClassModifiers={['pad-small']}>
                        <HorizontalFlex cssClassModifiers={['justify-center']}>
                            <Label>
                                <DateTimeString
                                    timestamp={nodeDetail.timestamp}
                                />
                            </Label>
                        </HorizontalFlex>
                    </PadContainer>
                </TicketHeader>
                <TicketBody>
                    <PadContainer cssClassModifiers={['pad-small']}>
                        <div className={ticketBodyClassName}>{translation}</div>
                    </PadContainer>
                </TicketBody>
            </Ticket>
        </>
    );
}

DetailItemContent.propTypes = {
    nodeDetail: PropTypes.instanceOf(Object),
    urlData: PropTypes.instanceOf(Object),
};
